export const MAX_ACTIVITY_ENTRY_COUNT = 4

export const ACTIVITY_ENTRY_TYPE_OPTIONS = [
  {
    value: 1,
    label: '首页悬浮窗',
    requiresStyle: false,
    styleLabel: '',
    styleOptions: []
  },
  {
    value: 2,
    label: '活动页悬浮窗',
    requiresStyle: false,
    styleLabel: '',
    styleOptions: []
  },
  {
    value: 3,
    label: '底部导航栏',
    requiresStyle: true,
    styleLabel: '选择图片',
    styleOptions: [{ value: 1, label: '默认图片' }]
  },
  {
    value: 4,
    label: '冷启动开屏',
    requiresStyle: false,
    styleLabel: '',
    styleOptions: []
  }
]

export const buildDefaultActivityEntry = (sortNum = 1) => ({
  entryType: '',
  entryStyle: '',
  imageFileId: '',
  imageFileUrl: '',
  sortNum
})

export const getActivityEntryTypeLabel = (value) => {
  const matched = ACTIVITY_ENTRY_TYPE_OPTIONS.find(
    (item) => item.value === Number(value)
  )
  return matched ? matched.label : ''
}

export const getActivityEntryStyleOptions = (entryType) => {
  const matched = ACTIVITY_ENTRY_TYPE_OPTIONS.find(
    (item) => item.value === Number(entryType)
  )
  return matched ? matched.styleOptions || [] : []
}

export const requiresActivityEntryStyle = (entryType) => {
  const matched = ACTIVITY_ENTRY_TYPE_OPTIONS.find(
    (item) => item.value === Number(entryType)
  )
  return !!(matched && matched.requiresStyle)
}

export const requiresActivityEntryUpload = (entryType) => {
  return Number(entryType) === 1 || Number(entryType) === 2 || Number(entryType) === 4
}

export const getActivityEntryStyleLabel = (entryType) => {
  const matched = ACTIVITY_ENTRY_TYPE_OPTIONS.find(
    (item) => item.value === Number(entryType)
  )
  return matched ? matched.styleLabel || '选择图片' : '选择图片'
}

export const getActivityEntryStyleText = (entryType, entryStyle) => {
  const matched = getActivityEntryStyleOptions(entryType).find(
    (item) => Number(item.value) === Number(entryStyle)
  )
  return matched ? matched.label : ''
}
